import React from 'react';
import { Flex, Icon, Text } from '@spothero/ui';
import IconCar from '@spothero/icons/car';
import IconClock from '@spothero/icons/clock';
import IconTicketEvent from '@spothero/icons/ticket-event';
export const ReviewRentalDetails = ({ vehicleType, duration, destination, }) => {
    return (<Flex gap={4} flexWrap="wrap" data-testid="ReviewRentalDetails">
            <Flex alignItems="center" gap={1}>
                <Icon as={IconClock} width="3" height="3" color="gray.500"/>
                <Text fontSize="xs">{duration}</Text>
            </Flex>
            {vehicleType && (<Flex alignItems="center" gap={1}>
                    <Icon as={IconCar} width="3" height="3" color="gray.500"/>
                    <Text fontSize="xs">{vehicleType}</Text>
                </Flex>)}
            {destination && (<Flex alignItems="center" gap={1}>
                    <Icon as={IconTicketEvent} width="3" height="3" color="gray.500"/>
                    <Text fontSize="xs">{destination}</Text>
                </Flex>)}
        </Flex>);
};
